









































import { Vue, Component } from 'vue-property-decorator';
import { GetMemberGroupsRequest, GetMemberGradesRequest } from 'supporter';
import { namespace } from 'vuex-class';
import TrTargetGradeGroup from '@/components/member/TrTargetGradeGroup.vue';
import { TargetType } from '@/components/promotion/discount/addForm/TargetSelector.vue';
const mallModule = namespace('mall');

@Component({
  components: {
    TrTargetGradeGroup,
  },
})
export default class MemberTargetDetail extends Vue {
  @mallModule.Getter('mallNameAndValues') readonly mallNameAndValues!: { name: string; value: string }[];

  private targetType: TargetType = 'PROMOTION';
  private discountNo = null;
  private memberGradeNos = null;
  private memberGroupNos = null;
  private memberGradeName = '';
  private memberGradeNames = '';
  private memberGroupName = null;
  private memberGroupNames = '';
  private discountName = null;
  private startYmdt = null;
  private endYmdt = null;
  private mallName = '';

  get typeLabel() {
    return this.$t(`PROMOTION_DISCOUNT_${this.targetType}`);
  }

  get periodLabel() {
    const label = this.targetType === 'PROMOTION' ? 'PROMOTION_DISCOUNT_PROMOTION' : 'PROMOTION_DISCOUNT_ISSUE_SCHEDULE';
    return this.$t(label);
  }

  mounted() {
    this.getQueryData();
    this.init();
  }

  private init(): void {
    this.getGroups();
    this.getGrades();
    // 대혼란
  }

  private closePopup() {
    window.close();
  }

  private getQueryData(): void {
    const { discountNo, discountName, startYmdt, endYmdt, memberGradeNos, memberGroupNos, type } = this.$route.query;

    this.discountNo = discountNo;
    this.discountName = discountName;
    this.startYmdt = startYmdt;
    this.endYmdt = endYmdt;
    this.memberGradeNos = memberGradeNos;
    this.memberGroupNos = memberGroupNos;
    this.targetType = type as TargetType;
    this.mallName = this.mallNameAndValues.find((mallName: any) => mallName.value === this.discountNo).name;
  }

  //공통 부분 함수로 분리하기

  private getGrades(): void {
    let request: GetMemberGradesRequest = {
      params: {
        mallNo: Number(this.discountNo),
        gradeNos: this.memberGradeNos,
      },
    };
    this.$api.getMemberGrades(request).then((res): any => {
      this.memberGradeName = res.data.length ? res.data[0].name : (this.$t('MEMBER_TARGET_MEMBER_ALL') as string);
      this.memberGradeNames = res.data.map(gradeName => gradeName.name).join();
    });
  }

  private getGroups(): void {
    let request: GetMemberGroupsRequest = {
      params: {
        mallNo: Number(this.discountNo),
        groupNos: this.memberGroupNos,
      },
    };
    this.$api.getMemberGroups(request).then((res): any => {
      this.memberGroupName = res.data.length ? res.data[0].name : (this.$t('MEMBER_TARGET_MEMBER_ALL') as string);
      this.memberGroupNames = res.data.map(groupName => groupName.name).join();
    });
  }
}
